/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import { Col, Icon, Input, message, Modal, Row, Table, Form, Button } from 'antd'
import { deleteCompanySetting, searchCompaynySetting } from '../../../authorization-module/user-role/duck/service'
import { FormComponentProps } from 'antd/es/form'
import { CompanyAuth } from '../../../authorization-module/people/model'
import CompanyFormModal from './CompanyForm'

type Props = FormComponentProps
const { Search } = Input
const { confirm } = Modal
const CompanyTab: React.FC<Props> = (props: Props) => {
    // const { getFieldDecorator, resetFields, validateFields, setFieldsValue, getFieldValue } = props.form
    const pageSize = 10
    const [page, setPage] = useState<number>(1)
    const [dataSource, setDataSource] = useState<CompanyAuth[]>()
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
    const [isModalVisibleEdit, setIsModalVisibleEdit] = useState<boolean>(false)
    const [isTableLoading, setIsTableLoading] = useState<boolean>(false)
    const [dataEdit, setDataEdit] = useState<CompanyAuth[]>()
    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [sortBy, setSortBy] = useState<string>('lastModifiedDatetime')
    const [orderBy, setOrderBy] = useState<string>('desc')
    const [onSearch, setOnSearch] = useState<string>('')
    const [isTableChange, setIsTableChange] = useState<boolean>(false)
    const [dataTotal, setDataTotal] = useState<number>(0)

    useEffect(() => {
        setIsTableLoading(true)
        searchCompaynySetting(sortBy, orderBy, page, pageSize, '').then((res) => {
            setDataSource(res.data)
            setDataTotal(res.total)
            setIsTableLoading(false)
            setIsTableChange(false)
        }).catch((err) => {
            console.log(err)
            setIsTableLoading(false)
            setIsTableChange(false)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isTableChange])

    useEffect(() => {
        setIsTableLoading(true)
        if (onSearch) {
            searchCompaynySetting(sortBy, orderBy, page, pageSize, onSearch).then((res) => {
                setDataSource(res.data)
                setDataTotal(res.total)
                setIsTableLoading(false)
            }).catch((err) => {
                console.log(err)
                setIsTableLoading(false)
            })
        } else {
            searchCompaynySetting(sortBy, orderBy, page, pageSize, '').then((res) => {
                setDataSource(res.data)
                setDataTotal(res.total)
                setIsTableLoading(false)
                setIsTableChange(false)
            }).catch((err) => {
                console.log(err)
                setIsTableLoading(false)
                setIsTableChange(false)
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, sortBy, orderBy, onSearch])

    const columns = [
        {
            title: '',
            dataIndex: '',
            key: '',
            width: '5%',
            render: (row) => (
                <>
                    <span><Icon type='delete' onClick={() => deleteCompany(row.id)}/></span>
                </>
            )
        },
        {
            title: '',
            dataIndex: '',
            key: '',
            width: '5%',
            render: (row) => (
                <>
                    <span><Icon type='edit' onClick={() => selectDataEdit(row)}/></span>
                </>
            )
        },
        {
            title: 'Company Name',
            dataTindex: ' ',
            key: 'companyName',
            width: '20%',
            render: (data) => (
                <>
                    {data.companyName}
                </>
            ),
            sorter: true
        },
        {
            title: 'Address',
            dataIndex: '',
            key: 'companyAddress',
            render: (data) => (
                <>
                    {data.companyAddress || ''}
                </>
            ),
            width: '50%',
            sorter: true
        },
        {
            title: 'Last Modified',
            dataIndex: '',
            key: '',
            render: (data) => (
                <>
                    {data.lastModifiedDate || data.lastModifiedDatetime}
                </>
            ),
            width: '20%'
        }
    ]

    const selectDataEdit = (row) => {
        setDataEdit(row)
        setIsEdit(true)
        setIsModalVisibleEdit(true)
    }

    const deleteCompany = (id) => {
        confirm({
            title: 'Are you sure?',
            content: 'Do you confirm Delete of this data ?',
            onOk() {
                setIsTableChange(true)
                deleteCompanySetting(id).then(() => {
                    message.success('Delete Company Name successfully.')
                }).catch((err) => {
                    console.log(err)
                }).finally(() => {
                    setIsTableChange(false)
                })
            },
            onCancel() {
                console.log('Cancel')
            }
        })
    }

    const closeModal = (value: any) => {
        setIsTableChange(true)
        setIsModalVisible(false)
        setIsModalVisibleEdit(false)
    }

    const handleOnClickPageNumber = (page: number) => {
        setPage(page)
    }

    const handleTableChange = (pagination, filters, sorter) => {
        console.log('sorter', sorter)
        if (sorter.order === 'ascend') {
            setOrderBy('ASC')
            if (sorter.columnKey) {
                setSortBy(sorter.columnKey)
            } else {
                setSortBy('companyName')
            }
        } else if (sorter.order === 'descend') {
            setOrderBy('DESC')
            if (sorter.columnKey) {
                setSortBy(sorter.columnKey)
            } else {
                setSortBy('companyName')
            }
        } else {
            setSortBy('lastModifiedDatetime')
        }
    }

    return (
        <div>
            <div style={{ overflow: window.innerWidth <= 768 ? 'auto' : 'none' }}>

                <div>
                    <br/>
                    <div>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Search
                                    placeholder="Can search Company Name and Address"
                                    onSearch={value => setOnSearch(value)}
                                    style={{ width: 300 }}
                                    id='search_company'
                                    allowClear
                                />
                            </Col>
                            <Col span={12}>
                                <Button type="primary" icon='plus' style={{ float: 'right' }} onClick={() => setIsModalVisible(true)}>Add Company</Button>
                            </Col>
                        </Row>
                        <br/>
                    </div>
                    <br />
                    <br />
                    <Table
                        loading={isTableLoading}
                        columns={columns}
                        dataSource={dataSource || []}
                        pagination={{
                            pageSize: pageSize,
                            current: page,
                            total: dataTotal || 0,
                            onChange: (event) => {
                                handleOnClickPageNumber(event)
                            }
                        }}
                        rowKey="id"
                        onChange={handleTableChange}
                        scroll={{ x: 768 }}
                    />
                    <Modal width={450} title='Add Company' footer={false} visible={isModalVisible} onCancel={() => setIsModalVisible(false)}>
                        <CompanyFormModal closeModal={closeModal}/>
                    </Modal>
                    <Modal width={450} title='Edit Company' footer={false} visible={isModalVisibleEdit} onCancel={() => setIsModalVisibleEdit(false)}>
                        <CompanyFormModal closeModal={closeModal} dataEdit={dataEdit} isEdit={isEdit}/>
                    </Modal>
                </div>
            </div>
        </div>
    )
}

const CompanyTabForm = Form.create<Props>()(CompanyTab)
export default CompanyTabForm
